<script lang="ts">
import { BuilderComponent } from '@/utils/cms';

export const CaptionRegistration: BuilderComponent = {
  name: 'Caption',
  canHaveChildren: true,
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Caption text here' } },
    },
  ],
  defaultStyles: {
    marginTop: '0px',
  },
  inputs: [
    {
      name: 'underline',
      type: 'boolean',
      defaultValue: false,
    },
  ],
};
</script>

<script setup lang="ts">
defineProps<{
  underline?: boolean;
}>();
</script>

<template>
  <p class="caption lg:text-xs" :class="{ underline: underline }">
    <slot />
  </p>
</template>

<style scoped>
.caption {
  @apply mb-0;
}
@media (max-width: 1024px) {
  .caption {
    font-size: 10px;
    line-height: 14px;
  }
}
</style>
